export default __webpack_public_path__ + "static/media/batiment-curve.5accfc54.jpg";